import { Chip } from '@mui/material';
import { onClickHandler } from './utilities/click_handler';
import colors from './colors';
import applyOpacity from './utilities/applyOpacity';

export type ChipProps = {
  content: React.ReactNode
  onClick?: () => void
  selected?: boolean
  color?: keyof typeof colors
  transparent?: boolean
  small?: boolean
};

export const ChipUI: React.FC<ChipProps> = ({ content: label, onClick, selected, color, transparent, small }) => {
  const finalColor = color ? applyOpacity(colors[color], transparent ? 85 : 100) : undefined;
  return (
    <Chip
      sx={{ borderRadius: '5px', backgroundColor: finalColor, maxWidth: '175px' }}
      label={label}
      onClick={onClick ? onClickHandler(onClick) : undefined}
      variant={selected ? 'filled' : 'outlined'}
      size={small ? 'small' : 'medium'}
      clickable={!!onClick}
    />
  );
};
